import { render, staticRenderFns } from "./flowForm.vue?vue&type=template&id=1b7f6395"
import script from "./flowForm.vue?vue&type=script&lang=js"
export * from "./flowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports